import React from "react";
import {Button, Col, Container, Modal, ModalBody, ModalHeader, Row} from "shards-react";
import {connect} from "react-redux";
import moment from 'moment';
import PageTitle from "./../../components/common/PageTitle";
import TableData from "./../../components/tables";
import {deleteLanguage, requestLanguages, searchLanguages, updateLanguage} from '../../actions/languages.action';

class Languages extends React.Component {
    constructor(props) {
        super(props);
        this.props.loadData();
        this.state = {
            ModalOpen: false,
            lastLanguageToDelete: null
        };
        this.toggleModal = this.toggleModal.bind(this);
    }
    updateLanguage = (e) => {
       let id = e.target.getAttribute("data-id");
       let active = e.target.getAttribute("data-active") !== 'true';
       let main = e.target.getAttribute("data-main") !== 'true';
       let payload = {
           id: id,
           active: active,
           main: main
       }
       this.props.updateLanguage(payload);
    }
    deleteLanguageButton = (e) => {
        this.state.lastLanguageToDelete = e.target.getAttribute("data-id");
        this.toggleModal();
    }
    deleteLanguage = (e) => {
        let payload = {
            id: e.target.getAttribute("data-id")
        }
        this.props.deleteLanguage(payload);
        this.toggleModal();
    }
    resetFilters = () => {
        this.props.loadData();
    }
    showActiveLanguages = () => {
        let payload = {
            showActive: true,
            _count: 1000
        };
        this.props.loadData(payload);
    }
    toggleModal() {
        this.setState({
            ModalOpen: !this.state.ModalOpen
        });
    }
    render() {
        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4">
                    <PageTitle title="Languages" subtitle="Languages" className="text-sm-left mb-3"/>
                </Row>
                <Row>
                    <Col className="col-lg col-lg-12 mb-3">
                        <Button theme="primary" onClick={this.showActiveLanguages}>Voir uniquement les langues actives</Button>
                        &nbsp;
                        <Button theme="secondary" onClick={this.resetFilters}>Reset la recherche</Button>
                    </Col>
                    <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
                        {this.props.languages.fetching ? (
                            <div className="flex-center">
                                <div className="text-center d-block">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <TableData
                                research={this.props.languages.searching}
                                tableData="languages"
                                dataColumns={[
                                    {
                                        Header: "Id",
                                        accessor: "id",
                                        maxWidth: 340,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.id}</span>
                                        ),
                                    },
                                   {
                                        Header: "Iso id",
                                        accessor: "isoId",
                                        maxWidth: 140,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.isoID}</span>
                                        ),
                                    },

                                    {
                                        Header: "Nom du langage",
                                        accessor: "name",
                                        maxWidth: 240,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.name}</span>
                                        ),
                                    },

                                    {
                                        Header: "Nom en anglais",
                                        accessor: "english_name",
                                        maxWidth: 240,
                                        className: "text-center",
                                        Cell: row => (
                                            <span>{row.original.english_name}</span>
                                        ),
                                    },
                                    {
                                        Header: "Activer ?",
                                        accessor: "active",
                                        maxWidth: 200,
                                        className: "text-center",
                                        Cell: row => (
                                            <div>
                                                    { row.original.active ===true ?
                                                            <Button
                                                                size="sm"
                                                                theme="primary"
                                                                data-id={row.original.id}
                                                                data-active={row.original.active}
                                                                onClick={(row) => this.updateLanguage(row)}
                                                            >Active</Button>
                                                        :
                                                        <Button
                                                            size="sm"
                                                            theme="secondary"
                                                            data-id={row.original.id}
                                                            data-active={row.original.active}
                                                            onClick={(row) => this.updateLanguage(row)}
                                                        >Inactive</Button>
                                                    }
                                            </div>
                                        ),
                                    },
                                    {
                                        Header: "Langage important ?",
                                        accessor: "main",
                                        maxWidth: 200,
                                        className: "text-center",
                                        Cell: row => (
                                            <div>
                                                { row.original.main ===true ?
                                                    <Button
                                                        size="sm"
                                                        theme="primary"
                                                        data-id={row.original.id}
                                                        data-main={row.original.main}
                                                        onClick={(row) => this.updateLanguage(row)}
                                                    >Oui</Button>
                                                    :
                                                    <Button
                                                        size="sm"
                                                        theme="secondary"
                                                        data-id={row.original.id}
                                                        data-main={row.original.main}
                                                        onClick={(row) => this.updateLanguage(row)}
                                                    >Non</Button>
                                                }
                                            </div>
                                        ),
                                    },
                                    {
                                        Header: "Date de modification.",
                                        accessor: "updated_at",
                                        className: "text-center",
                                        maxWidth: 140,
                                        Cell: row => (
                                            <span>{row.original.updated_at ? (moment(row.original.updated_at).format("DD/MM/YYYY")) : ('Date Invalide')}</span>
                                        )
                                    },
                                    {
                                        Header: "Supprimer ?",
                                        accessor: "active",
                                        maxWidth: 200,
                                        className: "text-center",
                                        Cell: row => (
                                            <Button theme="danger" size="sm" onClick={this.deleteLanguageButton} data-id={row.original.id} outline> x </Button>
                                        ),
                                    },


                                ]}
                                dataSearch={searchLanguages}
                                pageSize={100}
                                title={"Liste des langages"}
                                dataName={'languages'}
                            />
                        )}
                    </Col>
                </Row>
                <Modal centered={true} open={this.state.ModalOpen} toggle={this.toggleModal}>
                    <ModalHeader>Voulez vous vraiment supprimer cette langue ?</ModalHeader>
                    <ModalBody>
                        <Button theme="danger" data-id={this.state.lastLanguageToDelete} onClick={this.deleteLanguage}>Supprimer</Button>
                        &nbsp;
                        <Button theme="secondary" onClick={()=>this.toggleModal()}>Annuler</Button>
                    </ModalBody>
                </Modal>
            </Container>
        );
    }
}


function mapStateToProps(state) {
    return {
        languages: state['languages'],
    };
}

const mapDispatchToProps = dispatch => ({
    loadData: (e) => dispatch(requestLanguages(e)),
    updateLanguage: (e) => dispatch(updateLanguage(e)),
    deleteLanguage: (e) => dispatch(deleteLanguage(e))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Languages);



// WEBPACK FOOTER //
// ./src/views/Languages/Languages.js